import { Monitor, Moon, Sun, type LucideIcon } from 'lucide-react';
import { cn } from '@jeraisonne/ui';
import { THEME_PREFERENCES, useThemePreference, type ThemePreference } from '@/lib/app-theme';

const ICONS: Record<ThemePreference, LucideIcon> = {
  system: Monitor,
  light: Sun,
  dark: Moon,
};

/**
 * Choix du mode d'affichage (profil, tous rôles) : Automatique / Clair / Sombre.
 * Appliqué IMMÉDIATEMENT et mémorisé sur l'appareil — indépendant du bouton
 * « Enregistrer » du profil (cf. lib/app-theme.ts).
 */
export function ThemePreferenceControl() {
  const [pref, setPref] = useThemePreference();

  return (
    <div className="space-y-3">
      <div>
        <p className="text-ink-900 text-sm font-medium">Mode d’affichage</p>
        <p className="text-ink-400 text-xs">
          « Automatique » suit le réglage clair/sombre de ton appareil.
        </p>
      </div>
      <div
        role="radiogroup"
        aria-label="Mode d’affichage"
        className="bg-ink-100 grid grid-cols-3 gap-1 rounded-2xl p-1"
      >
        {THEME_PREFERENCES.map(({ value, label }) => {
          const Icon = ICONS[value];
          const active = pref === value;
          return (
            <button
              key={value}
              type="button"
              role="radio"
              aria-checked={active}
              onClick={() => setPref(value)}
              className={cn(
                'flex min-h-[2.75rem] items-center justify-center gap-1.5 rounded-xl text-sm font-semibold transition-all active:scale-[0.98]',
                active
                  ? 'text-primary-600 ocean:bg-[#123070] bg-[#ffffff] shadow-sm'
                  : 'text-ink-500 hover:text-ink-800',
              )}
            >
              <Icon className="h-4 w-4" aria-hidden="true" />
              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
